export default "__VITE_ASSET__DwPQ95Lh__"